import * as React from 'react';
import { Typography } from 'antd';
const { Title, Text, Paragraph } = Typography;
import { IWidget } from 'common/schema/widget/Widget';
import './FormWidgetGraphicSectionView.scss';
import { WidgetGraphicMultilineText } from '../helper/WidgetGraphicMultilineText';

export interface FormWidgetGraphicSectionViewProps {
  widget: IWidget;
}

export function FormWidgetGraphicSectionView(
  props: FormWidgetGraphicSectionViewProps
) {
  const { widget } = props;

  return (
    <Title level={4} className="graphic-section-title">
      {widget.graphic?.bordered && <div className="graphic-section-line"></div>}
      <WidgetGraphicMultilineText text={widget.graphic!.content} />
      {widget.graphic?.bordered && <div className="graphic-section-line"></div>}
    </Title>
  );
}
